import React from 'react';


const Svg = ():JSX.Element => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.5" d="M16 26L16 12" stroke="#0090FF" stroke-width="2"/>
      <path d="M3 26L3 17" stroke="#0090FF" stroke-width="2"/>
      <path d="M24 26L24 17" stroke="#0090FF" stroke-width="2"/>
      <path d="M8 26L8 17" stroke="#0090FF" stroke-width="2"/>
      <path d="M29 26L29 17" stroke="#0090FF" stroke-width="2"/>
      <path opacity="0.5" d="M2 29H30" stroke="#0090FF" stroke-width="2" stroke-linejoin="round"/>
      <path d="M2 24H12" stroke="#0090FF" stroke-width="2" stroke-linejoin="round"/>
      <path d="M20 24H30" stroke="#0090FF" stroke-width="2" stroke-linejoin="round"/>
      <path d="M2 20H11" stroke="#0090FF" stroke-width="2" stroke-linejoin="round"/>
      <path d="M21 20L30 20" stroke="#0090FF" stroke-width="2" stroke-linejoin="round"/>
      <path opacity="0.5" d="M25 8L29 8" stroke="#0090FF" stroke-width="2" stroke-linejoin="round"/>
      <path opacity="0.5" d="M4 11L6 11" stroke="#0090FF" stroke-width="2" stroke-linejoin="round"/>
      <path opacity="0.5" d="M2 7L8 7" stroke="#0090FF" stroke-width="2" stroke-linejoin="round"/>
      <path d="M12.3409 5.09282C13.1036 3.79616 14.4956 3 16 3C17.5044 3 18.8964 3.79616 19.6591 5.09282L21.5468 8.30191C24.0703 12.5919 20.9772 18 16 18C11.0228 18 7.92967 12.5919 10.4532 8.30191L12.3409 5.09282Z" stroke="#0090FF" stroke-width="2"/>
    </svg>
)

export default Svg;
